import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'
import $ from 'jquery'

import Icon from '../../Icons'
import { setFormFieldValue, validateFormField } from '../../../reducers/formReducer'

export class SelectField extends Component {
  constructor(props) {
    super(props)
    const { defaultValue, options } = props
    this.state = {
      dropdownOpen: false,
      value: defaultValue || '',
      inputVal: defaultValue
        ? options && options.length > 0 && options.find((item) => item.value === defaultValue).label
        : '',
    }
    this.clickHandler = this.clickHandler.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.selectOption = this.selectOption.bind(this)
  }

  componentDidMount() {
    $(document.body).on('click', this.clickHandler)
    const { formType, fieldName, defaultValue } = this.props
    const initialValue = defaultValue || ''
    if (formType && fieldName) {
      this.props.setFormFieldValue(formType, fieldName, initialValue)
      this.props.validateFormField(formType, fieldName, this.isValid(initialValue))
    }
  }

  componentWillUnmount() {
    $(document.body).off('click', this.clickHandler)
  }

  componentWillReceiveProps(nextProps) {
    // TODO state is not changing when defaultValue is not set but form[formType] is set to initialState
    const { formType, fieldName, options, defaultValue } = nextProps
    const initialValue = defaultValue || false
    if (
      (!_.isEqual(this.props.options, nextProps.options) ||
        this.props.defaultValue !== nextProps.defaultValue) &&
      fieldName &&
      formType
    ) {
      this.props.setFormFieldValue(formType, fieldName, initialValue)
      this.props.validateFormField(formType, fieldName, this.isValid(initialValue))
      this.setState({
        value: initialValue,
        inputVal: defaultValue
          ? options &&
            options.length > 0 &&
            options.find((item) => item.value === defaultValue).label
          : '',
      })
    }
  }

  clickHandler(e) {
    if ($(e.target).closest('.field-select .control').length === 0) {
      this.setState({ dropdownOpen: false })
    }
  }

  handleInput(e) {
    e.preventDefault()
    const { formType, fieldName, isDisabled, onChange } = this.props
    const value = e.target.value
    if (isDisabled) {
      return false
    }
    this.setState({ value, inputVal: value })
    if (formType && fieldName) {
      this.props.setFormFieldValue(formType, fieldName, value)
      this.props.validateFormField(formType, fieldName, this.isValid(value))
    } else if (onChange) {
      onChange(e, value)
    }
  }

  isValid(val) {
    return val && val.toString().length > 0
  }

  toggleDropdown(e) {
    e.preventDefault()
    const { formType, fieldName, dynamicOption, isDisabled } = this.props
    if (isDisabled) {
      return false
    }
    if (this.state.dropdownOpen) {
      this.setState({ dropdownOpen: false, inputVal: '' })
    } else {
      this.setState({ dropdownOpen: true, inputVal: '' })
    }
    if (dynamicOption) {
      this.props.setFormFieldValue(formType, fieldName, '')
      this.props.validateFormField(formType, fieldName, false)
    }
  }

  selectOption(e, value) {
    e.preventDefault()
    const { formType, fieldName, onChange, options } = this.props
    const selectedOption = options.find((item) => item.value === value) || false
    this.setState({
      dropdownOpen: false,
      value,
      inputVal: selectedOption ? selectedOption.label : value,
    })
    if (formType && fieldName) {
      this.props.setFormFieldValue(formType, fieldName, value)
      this.props.validateFormField(formType, fieldName, this.isValid(value))
    }
    if (typeof onChange !== 'undefined') {
      onChange(e, value)
    }
  }

  render() {
    const { label, options, additionalClass, placeholder, icon, dynamicOption, isDisabled } =
      this.props
    const { inputVal, value } = this.state
    let selectOptions
    if (inputVal !== '' && dynamicOption) {
      selectOptions = options.filter((item) => {
        return item.label.toLowerCase().includes(inputVal.toLowerCase())
      })
    } else {
      selectOptions = options
    }

    return (
      <div
        className={`field field-select ${
          this.state.dropdownOpen ? 'is-open' : ''
        } ${additionalClass || ''} ${isDisabled ? 'field--disabled' : ''}`}
      >
        {label && <label className="label">{label}</label>}
        <div className="control">
          <div className="select">
            <div className="field-select__input input" onClick={this.toggleDropdown}>
              {icon && <Icon icon={icon} />}
              {!dynamicOption && (
                <span>
                  {value || value === 0
                    ? options &&
                      options.length > 0 &&
                      options.find((item) => item.value === value) &&
                      options.find((item) => item.value === value).label
                    : placeholder || 'Select ...'}
                </span>
              )}
              {dynamicOption && (
                <input
                  type="text"
                  onChange={this.handleInput}
                  placeholder={placeholder || 'Select ...'}
                  value={inputVal}
                />
              )}
            </div>
            <div className={`field-select__dropdown`}>
              {selectOptions.length > 0 &&
                selectOptions.map((option, index) => {
                  return (
                    <span
                      key={index}
                      data-value={option.value}
                      onClick={(e) => this.selectOption(e, option.value)}
                    >
                      {option.label}
                    </span>
                  )
                })}
              {inputVal !== '' && dynamicOption && (
                <span
                  className="field-select__create-option"
                  onClick={(e) => this.selectOption(e, inputVal)}
                >
                  Create option: {inputVal}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

SelectField.propTypes = {
  form: PropTypes.object,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  additionalClass: PropTypes.string,
  icon: PropTypes.string,
  onChange: PropTypes.func,
  formType: PropTypes.string,
  formName: PropTypes.string,
  fieldName: PropTypes.string,
  // defaultValue must be a valid option from options array
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setFormFieldValue: PropTypes.func,
  validateFormField: PropTypes.func,
  placeholder: PropTypes.string,
  dynamicOption: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

export default connect(
  (state) => {
    return {
      form: state.form,
    }
  },
  { setFormFieldValue, validateFormField },
)(SelectField)
